<template>
  <div id="help">
    <PageHeader />
    <main>
      <div class="container mt-6">
        <h4>Bantuan</h4>
        <ol style="text-align: justify; padding: 0 0px 0 24px">
          <li v-for="(faq, idx) in faqList" :key="idx">
            <b>{{ faq.name }}</b>
            <br />
            <span v-html="faq.acceptedAnswer.text"></span>
            <br />
            <br />
          </li>
        </ol>
        <div>
          <h5>Punya pertanyaan lebih lanjut?</h5>
          <p>
            <a href="/contact"><strong>Hubungi kami</strong></a> atau kirim email ke
            <a href="mailto:help@rasylva.id" target="_blank" rel="noreferrer"><strong>help@rasylva.id</strong></a>
          </p>
        </div>
      </div>
    </main>
    <PageFooter />
  </div>
</template>

<script>
import PageFooter from '~/components/page-footer';
import PageHeader from '~/components/page-header';

export default {
  components: {
    PageFooter,
    PageHeader,
  },
  data: () => ({
    faqList: [
      {
        '@type': 'Question',
        'name': 'Apa itu Rasylva?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text':
            'Rasylva adalah pengembang software yang membantu proses pengolahan data di bidang ekologi dan kehutanan.',
        },
      },
      {
        '@type': 'Question',
        'name': 'Apa itu Inventum?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text':
            'Inventum adalah Alat Inventarisasi Tumbuhan yang dapat membantu kamu untuk menginput data tumbuhan secara offline, dengan output berupa spreadsheet yang dapat kamu unduh (xlsx/csv).',
        },
      },
      {
        '@type': 'Question',
        'name': 'Siapa yang dapat menggunakan Inventum?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text':
            'Inventum dapat digunakan oleh mahasiswa maupun profesional yang melakukan pengambilan data vegetasi ataupun penelitian di bidang ekologi dan kehutanan.',
        },
      },
      {
        '@type': 'Question',
        'name': 'Bagaimana cara mengunduh data Inventum?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text':
            'Buka tab View Records di aplikasi Inventum. Pilih menu Backup Record. Isi catatan dan tanggal. Kemudian pilih menu Download. Kamu juga bisa pilih menu Upload to Google Drive atau Send to Other App jika kamu menggunakan paket Pro.',
        },
      },
      {
        '@type': 'Question',
        'name': 'Dimanakah data Inventum disimpan?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text':
            'Seluruh Data Inventum (termasuk pengaturan dan data vegetasi) disimpan di dalam perangkat pengguna. Namun, data Nama Lokal yang akan disimpan di server Rasylva untuk membantu pengguna dalam memasukkan data Nama Lokal.',
        },
      },
      {
        '@type': 'Question',
        'name': 'Bagaimana jika saya ingin membatalkan pembelian paket?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text':
            'Silakan kirimkan pesan pembatalan ke email Rasylva dan sertakan alasan pembatalannya. Kami akan memproses pembatalan tersebut jika menurut kami alasannya dapat diterima. Pembatalan tersebut hanya dapat dilakukan dalam waktu 1x24 jam setelah melakukan pembayaran. Kamu akan dikenakan Biaya Pembatalan Lisensi sebesar Rp5.000. Pengembalian uangmu yang telah dipotong Biaya Pembatalan akan ditransfer melalui rekening atau dompet elektronik milikmu yang kamu kirimkan pada email tersebut.',
        },
      },
      {
        '@type': 'Question',
        'name': 'Bagaimana jika saya menemukan error/bug/kendala/kesalahan aplikasi?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text':
            'Kamu dapat melaporkan hal tersebut ke email Rasylva dan jelaskan kronologis yang terjadi. Laporan tersebut juga akan sangat membantu kami untuk menyempurnakan aplikasi kami.',
        },
      },
      {
        '@type': 'Question',
        'name': 'Bagaimana jika data saya hilang?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text':
            'Jika data hilang dikarenakan kamu melakukan Clear Cache atau tidak sengaja menekan menu Clear Records, maka kami tidak dapat membantu mengembalikan datanya. Harap berhati-hati ketika ingin menghapus data. Jika data hilang tiba-tiba dan menurut kamu itu adalah kesalahan sistem Inventum, silakan laporkan ke email Rasylva di help@rasylva.id dan jelaskan kronologis yang terjadi.',
        },
      },
      {
        '@type': 'Question',
        'name': 'Bagaimana jika perangkat saya hilang/rusak?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text':
            'Perangkatmu adalah tanggungjawab kamu sendiri. Rasylva tidak bertanggungjawab atas kehilangan perangkat yang kamu miliki.',
        },
      },
    ],
  }),
};
</script>
